import React from "react";
import PageShell from "../components/layout/PageShell";

export default function Photos() {
  // Démo : tu remplaces/ajoutes tes images dans /public/media/photos/
  const items = [
    { src: "/media/photos/promotion8_1.jpg", title: "Promotion — cérémonie", cat: "promotions" },
    { src: "/media/photos/promotion8_2.jpg", title: "Atelier — formation", cat: "formations" },
    { src: "/media/photos/promotion8_3.jpg", title: "Événement institutionnel", cat: "evenements" },
    { src: "/media/photos/promotion8_4.jpg", title: "Campus — salle", cat: "campus" },
  ];

  const params = new URLSearchParams(window.location.search);
  const cat = params.get("cat");
  const filtered = cat ? items.filter((x) => x.cat === cat) : items;

  return (
    <PageShell
      title="Photos"
      subtitle="Sélection officielle d’images — promotions, formations, événements et vie de l’École."
    >
      <div className="ema-actions-bar">
        <a className="ema-btn ema-btn-secondary" href="/mediatheque">← Médiathèque</a>
        <a className="ema-btn ema-btn-ghost" href="/mediatheque/photos">Toutes</a>
        <a className="ema-btn ema-btn-ghost" href="/mediatheque/photos?cat=promotions">Promotions</a>
        <a className="ema-btn ema-btn-ghost" href="/mediatheque/photos?cat=formations">Formations</a>
        <a className="ema-btn ema-btn-ghost" href="/mediatheque/photos?cat=evenements">Événements</a>
        <a className="ema-btn ema-btn-ghost" href="/mediatheque/photos?cat=campus">Campus</a>
      </div>

      <div className="ema-divider" />

      <div className="ema-gallery">
        {filtered.map((p) => (
          <figure key={p.src} className="ema-gallery-item">
            <img className="ema-gallery-img" src={p.src} alt={p.title} />
            <figcaption className="ema-gallery-cap">{p.title}</figcaption>
          </figure>
        ))}
      </div>

      <p className="ema-muted" style={{ marginTop: 12 }}>
      </p>
    </PageShell>
  );
}
